(() => {
  'use strict';

  if (window.__SQ_YML_UNIVERSAL_COMPAT__) return;
  window.__SQ_YML_UNIVERSAL_COMPAT__ = true;

  const HOST = '[data-sq-global-controller][data-lcs-expanded-controller]';
  const quantity = (value) => Math.max(1, Math.floor(Number(value) || 1));
  const clean = (value) => String(value ?? '').trim();

  function enhance(controller) {
    if (!controller || controller.__sqYmlUniversalCompat) return Boolean(controller);
    controller.__sqYmlUniversalCompat = true;

    controller.getExpandedCartItems = function getExpandedCartItems() {
      if (Array.isArray(this.expandedSelections) && this.expandedSelections.length) {
        return this.expandedSelections
          .filter((item) => clean(item?.variantId))
          .map((item) => ({
            ...item,
            quantity: quantity(item.quantity)
          }));
      }

      const item = this.currentItem?.();
      return item && clean(item.variantId)
        ? [{ ...item, quantity: quantity(item.quantity) }]
        : [];
    };

    controller.syncExpandedPurchaseState = function syncExpandedPurchaseState() {
      const hasSelections = Array.isArray(this.expandedSelections) && this.expandedSelections.length > 0;
      const add = this.section.querySelector('[data-lcs-expanded-add] span');
      const buy = this.section.querySelector('[data-lcs-expanded-buy] span');
      if (add) add.textContent = hasSelections ? 'Add Selected' : 'Add to Cart';
      if (buy) buy.textContent = hasSelections ? 'Buy Selected' : 'Buy Now';
    };

    controller.toggleFavorite = function toggleFavorite() {
      const item = this.currentItem?.();
      const store = window.LCSFavorites;
      if (!item || !store?.read || !store?.write) return;

      const productId = clean(item.productId);
      const handle = clean(item.handle);
      const items = store.read();
      const matches = (saved) =>
        (productId && clean(saved.productId) === productId) ||
        (handle && clean(saved.handle) === handle);
      const existing = items.find(matches);

      if (existing) {
        store.write(items.filter((saved) => !matches(saved)));
      } else {
        const now = new Date().toISOString();
        store.write([{
          ...item,
          key: item.key || `${productId || handle}|${clean(item.variantId) || 'default'}`,
          quantity: quantity(item.quantity),
          addedAt: item.addedAt || now,
          updatedAt: now
        }, ...items]);
      }

      this.updateFavoriteButton?.();
    };

    const originalRenderSelections = controller.renderSelections?.bind(controller);
    if (originalRenderSelections) {
      controller.renderSelections = function renderSelectionsCompat() {
        const result = originalRenderSelections();
        this.syncExpandedPurchaseState();
        return result;
      };
    }

    controller.syncExpandedPurchaseState();
    return true;
  }

  function install(root = document) {
    const hosts = [];
    if (root instanceof Element && root.matches(HOST)) hosts.push(root);
    root.querySelectorAll?.(HOST).forEach((host) => hosts.push(host));

    hosts.forEach((host) => {
      let attempts = 0;
      const wait = () => {
        if (enhance(host.__lcsFavoritesPage)) return;
        if (attempts++ < 360) requestAnimationFrame(wait);
      };
      wait();
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => install(), { once: true })
    : install();
  document.addEventListener('shopify:section:load', (event) => install(event.target));
})();
